import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import Button from './components/Button';

class ErrorBoundary extends Component {
    state = {
        hasError: false,
        eventId: null,
        jokes: ['Wanna hear a joke?', 'Shutdown! the computer may explode!'],
    };

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
        const isProd = process.env.NODE_ENV === 'production';
        const release = process.env.REACT_APP_SENTRY_RELEASE;

        if (isProd && release) {
            Sentry.withScope((scope) => {
                scope.setExtras(info);
                scope.setTag('source', 'ErrorBoundary');
                const eventId = Sentry.captureException(error);
                this.setState({ eventId });
            });
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{ textAlign: 'center', margin: 50 }}>
                    <h3>
                        Something went wrong, please click the button below to
                        report it
                    </h3>
                    <Button
                        onClick={() =>
                            Sentry.showReportDialog({
                                eventId: this.state.eventId,
                            })
                        }
                    >
                        Report Feedback
                    </Button>{' '}
                    <a href="/">
                        <Button type="link">Go to Dashboard</Button>
                    </a>
                </div>
            );
        }
        //when there's not an error, render children untouched
        return this.props.children;
    }
}

export default ErrorBoundary;
